<small class="form-error">
  <ion-icon class="icon" name="information-circle-outline"></ion-icon>
  <span [innerHtml]="innerHtml"></span>
  <ng-content></ng-content>
</small>